export default __webpack_public_path__ + "images/graphics/tidler-logo.svg";